import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const placeBetSpaceDiceGameService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/space-dice-game/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getTopBetsService = (data) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/space-dice-game/top-bets', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getMyBetsService = (data) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/space-dice-game/my-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params: data
  })
}
